export default __webpack_public_path__ + "static/media/bg_blue.5ec85add.jpg";